/* SiteSelectorFooter.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/new';
import { PrimaryCTA } from '@atlassian/amkt-common';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._4cvresu3{align-items:flex-end}";
const _ = "._1e0c1txw{display:flex}";
const siteSelectorFooterContainer = null;
const ANALYTICS_EVENT_CONTAINER_ONE_CLICK_INSTALL_DIALOG = 'oneClickInstallDialog';
export const SiteSelectorFooter = _ref => {
  let {
    onClose,
    isLoading,
    isInstallCTADisabled,
    installCTALabel,
    installCTAHref,
    canUserInstallApp,
    onSiteSelectorFooterInstallCTAClick
  } = _ref;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onInstallClick = e => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      source: ANALYTICS_EVENT_CONTAINER_ONE_CLICK_INSTALL_DIALOG,
      actionSubjectId: canUserInstallApp ? 'installButton' : 'requestAppButton',
      attributes: {
        eventContainer: ANALYTICS_EVENT_CONTAINER_ONE_CLICK_INSTALL_DIALOG,
        hosting: 'cloud',
        label: installCTALabel,
        source: ANALYTICS_EVENT_CONTAINER_ONE_CLICK_INSTALL_DIALOG,
        category: 'appListing'
      }
    });
    onSiteSelectorFooterInstallCTAClick(e, canUserInstallApp, installCTAHref);
  };
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1e0c1txw _4cvresu3 _2lx21bp4"]),
      children: /*#__PURE__*/_jsxs(ButtonGroup, {
        children: [/*#__PURE__*/_jsx(Button, {
          appearance: "subtle",
          onClick: onClose,
          children: "Cancel"
        }), /*#__PURE__*/_jsx(PrimaryCTA, {
          isLoading: isLoading,
          isDisabled: isInstallCTADisabled,
          onClick: e => onInstallClick(e),
          children: installCTALabel
        })]
      })
    })]
  });
};